import React, { Component } from 'react';
import History from 'Store/history';

class UndefinedDeepLink extends Component {
  
  componentDidMount () {
    History.replace({
      pathname: '/kampanyalar',
      state: {
        showWheelOfFortuneModal: true,
      }
    });
  }

  redirectCampaing = () => {
    History.replace({
      pathname: '/kampanyalar',
      state: {
        showWheelOfFortuneModal: true,
      }
    });
  };
  
  render () {
    return (
      <>
      { this.redirectCampaing }
      </>
    );
  }
}


export default UndefinedDeepLink;
